module.exports = __webpack_public_path__ + "img/2.ed2d28d7.png";